import { Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root:{
    width: 230,
    [theme.breakpoints.up(350)]: {
      width:270
    },
    [theme.breakpoints.up("lg")]: {
      width:270
    },
  }
}))

export const Teamcard = (props: any) => {
  const classes= useStyles()
  return (
    <Box
      display="flex"
      flexDirection={"column"}
      justifyContent="space-between"
      marginTop={10}
      style={{
        borderRadius: 10,
      }}
      className={classes.root}
      bgcolor={"#141420"}
      height={200}
      paddingX={{xs:6, lg: 5}}
    >
      <Box style={{ position: "relative", top: "-40px" }}>{props.img}</Box>

      <Box color={"#fff"} style={{ position: "relative", top: "-40px" }}>
        <Typography
          style={{ fontFamily: "Poppins", fontSize: "20px", fontWeight: 600 }}
        >
          {props.name}
        </Typography>
      </Box>
      <Box color={"#fff"} style={{ position: "relative", top: "-40px" }}>
        <Typography
          style={{ fontFamily: "Poppins", fontSize: "15px", fontWeight: 400, color: "#C6C6C6" }}
        >
          {props.title}
        </Typography>
      </Box>
      <Box style={{ position: "relative", top: "-40px" }}>{props.icon}</Box>
    </Box>
  );
};
